import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ApolloProvider } from '@apollo/client';
import theme from '@motivo/guanyin/src/theme';
import { Box, Link } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './routes/Login';
import Callback from './routes/Callback';
import apolloClient from './apollo/client';
import PluginContainer from './components/PluginContainer';

function ProtectedRoute({ children, ...rest }: any) {
  const { isAuthenticated } = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

function MainApp() {
  const { logout } = useAuth();

  return (
    <Box display="flex" flexDirection="column" height="100vh">
      <Box flexGrow={1}>
        <PluginContainer />
      </Box>
      <Box borderTop={1} borderColor="divider">
        <Box display="flex" alignItems="center" justifyContent="flex-end" p={2} px={4}>
          <Link
            component="button"
            fontSize={14}
            color="secondary"
            sx={{ fontWeight: 500 }}
            onClick={logout}
            underline="none"
          >
            Log out
          </Link>
        </Box>
      </Box>
    </Box>
  );
}

function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <AuthProvider>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/callback" component={Callback} />
              <ProtectedRoute path="/">
                <MainApp />
              </ProtectedRoute>
            </Switch>
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </ApolloProvider>
  );
}

export default App;
